import ConnectSecondaryChannelWidget from "../components/ConnectSecondaryChannelWidget";
import { useShopifyConnectionStatus } from "./useShopifyConnectionStatus";

export const ShopifySecondaryChannelLink = () => {
  const { data: connectionStatus } = useShopifyConnectionStatus();
  const isConnected = connectionStatus?.is_connected ?? false;

  return (
    <ConnectSecondaryChannelWidget
      secondaryChannel="shopify"
      linkToSummaryView={
        isConnected ? "/user/shopifysummary" : "/onboarding/v2/connect?channel=shopify&secondaryChannel=shopify"
      }
      onClick={() => {
        if (!isConnected) {
          localStorage.setItem("secondaryChannel", "shopify");
        }
      }}
    />
  );
};
